<template>
    <div>
        <div class="w_1200 clearfix2 box_mh20">
            <div class="fl black6_text box_pt8">今天是 <span v-text="now"></span></div>
            <div class="fr" hidden>
                <Search/>
            </div>
        </div>
        <!--end一行-->

        <div class="clearfix2 box_mt20 w_1200">
            <div class="w_1200">
                <div class="clearfix2 gray_bj box_ph15 box_pw20">
                    <div class="fr black6_text box_pt8">共 <span v-text="pagination.total">0</span>条公告，每页显示<span v-text="params.rows"></span>条公告</div>

                    <div class="r_cell">
                        <input type="text" class="fill_text" placeholder="请输入宗地编号..." v-model="params.zybh">
                        <select class="select_box box_ml10" v-model="params.qy">
                            <option :value="null">选择区域</option>
                            <option v-for="(value,key,index) in qy" :key="index" :value="value" v-text="key"></option>
                        </select>
                        <input type="text" class="fill_text box_ml10" placeholder="请输入宗地名称..." v-model="params.xmmc">
                        <input type="button" class="fill_btn box_ml10" value="搜索" @click="getAllData">
                    </div>
                </div>
            </div>
            <!--end一行-->

            <table class="list_table blue_link box_c hover_table_bj box_mt20">
                <thead>
                <tr class="black9_text">
                    <th width="20px;"></th>
                    <th width="60px;">所属区域</th>
                    <th width="80px;">交易类型</th>
                    <th width="150px;">宗地编号</th>
                    <th width="150px;">公告编号</th>
                    <th width="200px;">宗地名称</th>
                    <th width="80px;">发布时间</th>
                    <th width="80px;">交易状态</th>
                    <th width="30px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box blue_bj" v-text="index+1"></span></td>
                    <td v-text="data.qyText"></td>
                    <td v-text="data.jylxText"></td>
                    <td v-text="data.zybh"></td>
                    <td v-text="data.ggh"></td>
                    <td v-text="data.xmmc"></td>
                    <td v-text="data.ggfbsj"></td>
                    <td v-text="data.jyztText"></td>
                    <td><a href="javascript:void(0);" @click="detailUrlByZyztAndId(data.jyztCode, data.extData && data.extData.ggwzId ? data.extData.ggwzId : data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="10" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <Pagination :pagination="pagination" :params="params" :start="start" :end="end" :maxEnd="maxEnd" @changeStartAndEnd="changeStartAndEnd"/>

        </div>
        <!--end一行-->

    </div>
</template>

<script>
    import {api} from "@/core/api"
    import {getNow} from '@/core/common'
    import axios from '@/core/http'
    import {detailUrl} from '@/core/getDetailUrl'
    import Ggzw from '@/components/Ggzw'
    import Search from "@/components/Search";
    import Pagination from "@/components/Pagination";

    export default {
        name: "Home",
        components: {Pagination, Search},
        data() {
            return {
                detailUrl: detailUrl,
                now: null,
                dataList: [],
                pagination: {
                    currentPage: 1,
                    rows: 10,
                    total: 0,
                    totalPage: 1
                },
                qy: {},
                params: {
                    page: 1,
                    rows: 10,
                    zybh: null,
                    qy: null,
                    xmmc: null,
                    bt: null
                },
                start: 1,
                end: 1,
                maxEnd: 5,
            }
        },
        mounted() {
            this.now = getNow();
            this.getAllData();
            this.getQy();
        },
        methods: {
            changeStartAndEnd(start, end) {
                this.start = start;
                this.end = end;
            },
            async getQy() {
                let res = await axios.get('/api/common/getQy');
                this.qy = res.data.data;
            },
            detailUrlByZyztAndId(jyztCode, id) {
                if (jyztCode === "01") {
                    location.href = detailUrl.zzgg(id);
                } else if (jyztCode === "02") {
                    location.href = detailUrl.zzgp(id);
                } else if (jyztCode === "03" || jyztCode === "04") {
                    location.href = detailUrl.jjjg(id);
                } else if (jyztCode === "05" || jyztCode === "06") {
                    this.read(id);
                }
            },
            getAllData() {
                this.params.page = 1;
                api.getSyzyList(this.params).then(response => {
                    this.dataList = response.data;
                });
                api.getSyzyPagination(this.params).then(response => {
                    if (response.code === 200) {
                        this.pagination = response.data;
                        this.start = 1;
                        this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                    } else {
                        console.log(response.msg)
                    }
                })
            },
            getDataByPage(){
                api.getSyzyList(this.params).then(response => {
                    this.dataList = response.data;
                });
            },
            read(id) {
                api.getDetailById({category: "Ggwz", id: id}).then(response => {
                    let bt = response.data.ggbt || response.data.bt;
                    let content = response.data.ggzw || response.data.zw;

                    this.$layer.iframe({
                        content: {
                            content: Ggzw, //传递的组件对象
                            parent: this,//当前的vue对象
                            data: {
                                content: `<h2 style="font-weight: bold; margin: 20px auto; text-align: center;">${bt}</h2><div>${content}</div>`
                            }
                        },
                        area: ['1300px', '700px'],
                        title: response.data.ggwzlxText || '公告',
                        scrollbar: false
                    });
                });
            }
        },
        watch: {
            "params.page": {
                handler() {
                    this.getDataByPage()
                }
            }
        }
    }
</script>

<style scoped>

</style>
